export default function Tooltip(theme) {
  return {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          boxShadow: theme.customShadows.shadowLightSM,
          fontSize: "12px",
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.grey.g7,
          borderRadius: "4px",
        },
        arrow: {
          color: theme.palette.grey.g7,
          border: "transparent",
        },
      },
    },
  };
}
